import { MantineProvider } from '@mantine/core'
import type { ReactNode } from 'react'
import { customTheme } from 'settings/ui-theme'

// Map badges render into their own React roots, where Mantine throws without a provider. CSS variables
// already come from App's.

export const OverlayMantineProvider = ({ children }: { children: ReactNode }) => {
  return (
    <MantineProvider theme={customTheme} withCssVariables={false} withGlobalClasses={false}>
      {children}
    </MantineProvider>
  )
}
